import {
  CheckCircleFilled,
  CloseCircleFilled,
  WarningFilled,
} from '@ant-design/icons';
import ValidationIssuesPopover from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/ValidationIssuesPopover';

const STATUS_ICON = {
  error: <CloseCircleFilled style={{ color: '#ff4d4f', fontSize: 16 }} />,
  warning: <WarningFilled style={{ color: '#faad14', fontSize: 16 }} />,
  success: <CheckCircleFilled style={{ color: '#52c41a', fontSize: 16 }} />,
};

const StatusCellRenderer = ({ node, api }) => {
  const data = node.data;
  const status = data?.status?.toLowerCase();

  if (!status) return null;

  if (status === 'success') {
    return (
      <span
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: 2,
        }}
      >
        {STATUS_ICON.success}
      </span>
    );
  }

  return (
    <ValidationIssuesPopover
      data={data}
      api={api}
      icon={STATUS_ICON[status]}
    />
  );
};

export default StatusCellRenderer;
